<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body">
    <label class="catlabel"> {{description}}</label>
</div>


<div class="footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">CONFIRM</button>
</div>